import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PMA_GATEWAY } from '@prlw/core/pma/pma-gateway.interface';
import { PMA_DATA_CONFIG } from './pma-data-config.token';
import { HttpPmaGateway } from './http-pma.gateway';

export type PmaDataConfig = {
  apiPrefix: string;
};

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: PMA_GATEWAY, useClass: HttpPmaGateway },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class PmaDataModule {
  public static forRoot(
    config: PmaDataConfig,
  ): ModuleWithProviders<PmaDataModule> {
    return {
      ngModule: PmaDataModule,
      providers: [{ provide: PMA_DATA_CONFIG, useValue: config }],
    };
  }
}
